import { render, staticRenderFns } from "./element-due-date.vue?vue&type=template&id=45920ffc&scoped=true"
import script from "./element-due-date.vue?vue&type=script&lang=js"
export * from "./element-due-date.vue?vue&type=script&lang=js"
import style0 from "./element-due-date.vue?vue&type=style&index=0&id=45920ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45920ffc",
  null
  
)

export default component.exports